export default {"src":"/_next/static/media/link.4906fc7a.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};